module.exports = __webpack_public_path__ + "static/media/solta_logo.9a38ea68.svg";